import { render } from "./Shopping_Cart.vue?vue&type=template&id=3b536548"
import script from "./Shopping_Cart.vue?vue&type=script&lang=js"
export * from "./Shopping_Cart.vue?vue&type=script&lang=js"

import "./Shopping_Cart.vue?vue&type=style&index=0&id=3b536548&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__